import { KEYWORD_STRINGS } from './common/constants.js';
/**
 * ValueConverter that extracts keywords from quoted strings.
 * Only converts strings that are actual keywords (defined in KEYWORD_STRINGS).
 * For terminals matching patterns like "keyword", this extracts just "keyword" without quotes.
 */
export class KeywordValueConverter {
    convert(input) {
        // Check if input matches a string in the keyword strings set
        if (typeof input === 'string' && KEYWORD_STRINGS.has(input)) {
            // Extract the keyword without quotes
            const keyword = input.slice(1, -1);
            return keyword;
        }
        // Return as-is for non-quoted values or non-keyword strings
        return input;
    }
}
//# sourceMappingURL=keyword-value-converter.js.map